import useLogger from 'lib/util/useLogger'

const debug = useLogger('Persona Provider', 'lightblue')

/**
 * Parse the bases
 *
 * @param {object} props - the input props
 * @returns {Array} the parsed bases
 */
export default function parseBases (props) {
  const { bases, elementsKeys } = props

  return bases.reduce((res, base, i) => {
    const { base_id, face_id } = base
    const baseData = elementsKeys[base_id]
    const faceData = elementsKeys[face_id]

    if (baseData && faceData) {
      if (baseData.style.join(',') !== faceData.style.join(',')) {
        debug.error(
          'Mismatch between face and body style',
          base,
          baseData,
          faceData
        )

        return res
      }

      res.push({
        compatible: [],
        ...base,
        gender: baseData.gender,
        name: base?.name || 'Untitled',
        id: `base_${i}`,
        layer: 'base',
        isBase: true,
        canDeselect: false,
        createdBy: baseData?.createdBy,
        brand: baseData?.brand,
        layers: [baseData?.image, faceData?.image],
        avatarLayerOrder: faceData?.layer_order || [],
        codes: { base: base_id, face: face_id },
        price: baseData.price + faceData.price,
        isAvailable: baseData.isAvailable && faceData.isAvailable,
        supply: Math.min(
          Number(baseData.supply) || 0,
          Number(faceData.supply) || 0
        ),
        style: faceData.style
      })
    } else {
      debug.error('Missing base/face data for base:', base)
    }

    return res
  }, [])
}
